import { render, staticRenderFns } from "./ShopCakeTabe.vue?vue&type=template&id=ac72e17e&scoped=true&"
import script from "./ShopCakeTabe.vue?vue&type=script&lang=js&"
export * from "./ShopCakeTabe.vue?vue&type=script&lang=js&"
import style0 from "./ShopCakeTabe.vue?vue&type=style&index=0&id=ac72e17e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac72e17e",
  null
  
)

export default component.exports